<template>
  <v-dialog
    :value="value"
    persistent
    max-width="520"
    overlay-opacity="0.85"
    content-class="encuesta-twilio-dialog"
  >
    <v-card flat outlined class="rounded-lg">
      <v-card-title class="py-4 primary white--text">
        <v-icon left color="white">mdi-speedometer</v-icon>
        Encuesta de rendimiento
      </v-card-title>

      <v-card-text class="pt-6 pb-2 px-6">
        <p class="text-body-1 mb-0 text-center">
          ¿El tiempo es óptimo al cargar tus contactos y la conversación de Twilio?
        </p>
      </v-card-text>

      <v-card-actions class="px-6 pb-6 pt-4 justify-center">
        <v-btn
          large
          depressed
          color="success"
          class="rounded-lg px-8 mr-3"
          :loading="enviando"
          :disabled="enviando"
          @click="enviar(true)"
        >
          Sí
        </v-btn>
        <v-btn
          large
          depressed
          color="error"
          class="rounded-lg px-8"
          :loading="enviando"
          :disabled="enviando"
          @click="enviar(false)"
        >
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validarErrores from '@/mixins/validarErrores';

export default {
  name: 'EncuestaTwilioModal',
  mixins: [validarErrores],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      enviando: false,
    };
  },
  methods: {
    enviar(respuestaOptima) {
      if (this.enviando) return;
      this.enviando = true;
      this.$http
        .post('encuesta-twilio.responder', { respuesta_optima: respuestaOptima ? 1 : 0 })
        .then(() => {
          this.validarSuccess('Gracias por tu respuesta');
          this.$emit('respondida');
          this.$emit('input', false);
        })
        .catch((error) => {
          const msg =
            (error.response && error.response.data && error.response.data.message) ||
            'No se pudo guardar tu respuesta';
          this.validarErrorDirecto(msg);
        })
        .finally(() => {
          this.enviando = false;
        });
    },
  },
};
</script>

<style scoped>
.encuesta-twilio-dialog {
  z-index: 10000 !important;
}
</style>
